import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useOktaAuth } from "../hooks/oktaAuth";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { getClientId } from "../store/api/core";
import applicationConfiguration from "../../config/application";
var ErrorOnNoRedirect = function () {
    var _a = useState(_jsx(Box, {})), page = _a[0], setPage = _a[1];
    useEffect(function () {
        setTimeout(function () {
            setPage(_jsx("div", { children: "Error: can not deduce auth state from Okta" }));
        }, 5000);
    });
    return page;
};
export var RequiredAuth = function () {
    var _a;
    var _b = useOktaAuth(), oktaAuth = _b.oktaAuth, authState = _b.authState;
    var referrerHostname = document.referrer
        ? new URL(document.referrer).hostname
        : "";
    var hostname = window.location.hostname;
    if (referrerHostname && referrerHostname !== hostname) {
        localStorage.setItem("referrer", referrerHostname);
        if (!getClientId()) {
            for (var _i = 0, _c = (_a = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.clientIdFeeders) !== null && _a !== void 0 ? _a : []; _i < _c.length; _i++) {
                var _d = _c[_i], referrerRegex = _d.referrerRegex, client = _d.client;
                var regex = new RegExp(referrerRegex);
                if (!regex.test(referrerHostname)) {
                    continue;
                }
                localStorage.removeItem("referrer");
                var url = new URL(window.location.href);
                url.searchParams.set("client", client);
                window.location.href = url.toString();
                return _jsx(_Fragment, {});
            }
        }
    }
    if (!authState || !(authState === null || authState === void 0 ? void 0 : authState.isAuthenticated)) {
        var originalUri = toRelativeUrl(window.location.href, window.location.origin);
        if (authState) {
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();
        }
        else {
            return _jsx(ErrorOnNoRedirect, {});
        }
        return _jsx(ErrorOnNoRedirect, {});
    }
    return _jsx(Outlet, {});
};
